// ─────────────────────────────────────────────────────────────────────────────
// CONFIGURATION DU SITE — EMBEK GROUP
// Coordonnées, zone d'intervention et horaires : tout se modifie ICI.
// ─────────────────────────────────────────────────────────────────────────────

export const site = {
  name: "Embek Group",
  tagline: "Votre extérieur, notre savoir-faire.",
  baseline:
    "Embek Group prend soin de vos jardins et espaces verts avec professionnalisme, précision et passion.",
  domain: "https://www.embekgroup.fr", // ⚠️ PLACEHOLDER — domaine définitif à renseigner

  // Téléphone de l'entreprise
  phone: "+32 456 95 38 89",
  phoneHref: "tel:+32456953889",

  // ⚠️ Numéro WhatsApp (format international, sans espaces) — passer à null pour masquer le bouton
  whatsapp: "32456953889",

  // E-mail de réception des demandes (devis, contact, rendez-vous)
  email: "info@embekgroup.be",

  // Adresse — affichée UNIQUEMENT dans les mentions légales (et la politique de confidentialité)
  address: "Chaussée de Waterloo 200/8, 1640 Rhode-Saint-Genèse",

  zone: "Charleroi · Namur · Mons",

  // Zone d'intervention réelle — communes desservies (modifiable ici à tout moment).
  // `ville` relie la zone à sa page locale (/jardinier-charleroi, etc.) — null sinon.
  zones: [
    {
      name: "Charleroi",
      ville: "charleroi",
      communes: [
        "Charleroi", "Châtelet", "Courcelles", "Fleurus", "Farciennes",
        "Fontaine-l'Évêque", "Gerpinnes", "Montigny-le-Tilleul", "Pont-à-Celles",
        "Les Bons Villers", "Aiseau-Presles", "Chapelle-lez-Herlaimont",
        "Couillet", "Dampremy", "Gilly", "Gosselies", "Goutroux", "Jumet",
        "Lodelinsart", "Marchienne-au-Pont", "Marcinelle", "Monceau-sur-Sambre",
        "Montignies-sur-Sambre", "Mont-sur-Marchienne", "Ransart", "Roux",
      ],
    },
    {
      name: "Namur",
      ville: "namur",
      communes: [
        "Namur", "Andenne", "Assesse", "Éghezée", "Fernelmont", "Floreffe",
        "Fosses-la-Ville", "Gembloux", "Gesves", "Jemeppe-sur-Sambre",
        "La Bruyère", "Mettet", "Ohey", "Profondeville", "Sambreville", "Sombreffe",
      ],
    },
    {
      name: "Mons",
      ville: "mons",
      communes: [
        "Mons", "Boussu", "Colfontaine", "Dour", "Frameries", "Hensies",
        "Honnelles", "Jurbise", "Lens", "Quaregnon", "Quévy", "Quiévrain", "Saint-Ghislain",
      ],
    },
    {
      name: "Mons — localités",
      ville: null,
      communes: [
        "Ciply", "Cuesmes", "Flénu", "Ghlin", "Harmignies", "Harveng", "Havré",
        "Hyon", "Jemappes", "Maisières", "Mesvin", "Nimy", "Nouvelles", "Obourg",
        "Saint-Denis", "Saint-Symphorien", "Spiennes", "Villers-Saint-Ghislain",
      ],
    },
  ],

  horaires: [
    { jours: "Lundi — Vendredi", heures: "8h00 – 18h00" },
    { jours: "Samedi", heures: "8h00 – 17h00" },
    { jours: "Dimanche", heures: "Fermé" },
  ],

  // Liens réseaux sociaux — laisser vide pour masquer les icônes
  social: [],
};

export const navLinks = [
  { label: "Accueil", to: "/" },
  { label: "Nos services", to: "/services" },
  { label: "À propos", to: "/a-propos" },
  { label: "Réalisations", to: "/realisations" },
  { label: "Avis clients", to: "/avis" },
  { label: "Conseils", to: "/conseils" },
  { label: "Contact", to: "/contact" },
  { label: "Rendez-vous", to: "/rendez-vous" },
];

export const quoteTypes = [
  "Entretien de jardins",
  "Tonte de pelouse",
  "Taille de haies",
  "Taille et élagage",
  "Création de jardin",
  "Aménagement paysager",
  "Pose de gazon / semis",
  "Nettoyage extérieur",
  "Vide-cave / débarras",
  "Remise en état de terrain",
  "Contrat d'entretien régulier",
  "Autre demande",
];
